import React, { Component } from "react";
import PropTypes from "prop-types";
import Input from "../Formsy/Input";
import theme from "../../themes/green";
import { withFormsy } from "formsy-react";
import Radium from "radium";
//arrow-right
//chain-2

class JumperFormsyPaddingController extends Component {
  constructor() {
    super();
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.state = {
      focused: "none"
    };
  }

  onChange(event) {
    const { getValue, setValue, style } = this.props;
    const val = this.props.getValue();
    const key = event.nativeEvent.target.name;
    const newVal = event.nativeEvent.target.value;
    this.props.setValue({
      ...val,
      [key]: newVal
    });
  }

  onFocus(event) {
    this.setState({ focused: event.nativeEvent.target.name });
  }

  onBlur() {
    this.setState({ focused: "none" });
  }

  showError() {
    if (this.props.isPristine()) {
      return false;
    }

    return !this.props.isValid();
  }

  getPropsForState() {
    const { showRequired } = this.props;

    return {
      error: this.showError(),
      showRequired: showRequired()
    };
  }

  render() {
    return (
      <div
        style={{
          margin: "50px 0",
          display: "flex",
          flexDirection: "row"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "25%"
          }}
        >
          <Input
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            name="top"
            placeholder="Top"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 },
              textAlign: "right"
            }}
            /* forceBackground */
            value={this.props.getValue().top}
            onChange={this.onChange}
          />
          <Input
            onFocus={this.onFocus}
            name="left"
            placeholder="Left"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 },
              textAlign: "right"
            }}
            /* forceBackground */
            value={this.props.getValue().left}
            onChange={this.onChange}
          />
        </div>
        <div
          style={{
            width: "100px",
            margin: "0 20px"
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              margin: "auto",
              border: `2px solid ${theme.pallete.lightBackground}`
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "18px",
                left: "18px",
                width: "60px",
                height: "60px",
                borderTop: `2px solid ${
                  this.state.focused == "top"
                    ? theme.pallete.color
                    : theme.pallete.lightBackground
                }`,
                borderRight: `2px solid ${
                  this.state.focused == "right"
                    ? theme.pallete.color
                    : theme.pallete.lightBackground
                }`,
                borderBottom: `2px solid ${
                  this.state.focused == "bottom"
                    ? theme.pallete.color
                    : theme.pallete.lightBackground
                }`,
                borderLeft: `2px solid ${
                  this.state.focused == "left"
                    ? theme.pallete.color
                    : theme.pallete.lightBackground
                }`
              }}
            >
              <span
                className="icon-chain-2"
                style={{
                  color: theme.pallete.lightBackground,
                  lineHeight: "60px",
                  width: "60px",
                  textAlign: "center",
                  fontSize: "20px",
                  display: "inline-block"
                }}
              />
            </div>
            <span
              style={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translate(-50%,0) rotate(-90deg)",
                color: `${
                  this.state.focused == "top"
                    ? theme.pallete.color
                    : theme.pallete.lightBackground
                }`
              }}
              className="icon-arrow-right"
            />
            <span
              style={{
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translate(-50%,0) rotate(90deg)",
                color: `${
                  this.state.focused == "bottom"
                    ? theme.pallete.color
                    : theme.pallete.lightBackground
                }`
              }}
              className="icon-arrow-right"
            />
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: 0,
                transform: "translate(0,-50%) rotate(180deg)",
                color: `${
                  this.state.focused == "left"
                    ? theme.pallete.color
                    : theme.pallete.lightBackground
                }`
              }}
              className="icon-arrow-right"
            />
            <span
              style={{
                position: "absolute",
                top: "50%",
                right: 0,
                transform: "translate(0,-50%) rotate(0deg)",
                color: `${
                  this.state.focused == "right"
                    ? theme.pallete.color
                    : theme.pallete.lightBackground
                }`
              }}
              className="icon-arrow-right"
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column-reverse",
            width: "25%"
          }}
        >
          <Input
            onFocus={this.onFocus}
            name="bottom"
            placeholder="Bottom"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 },
              textAlign: "left"
            }}
            /* forceBackground */
            value={this.props.getValue().bottom}
            onChange={this.onChange}
          />
          <Input
            onFocus={this.onFocus}
            name="right"
            placeholder="Right"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 },
              textAlign: "left"
            }}
            /* forceBackground */
            value={this.props.getValue().right}
            onChange={this.onChange}
          />
        </div>
      </div>
    );
  }
}

JumperFormsyPaddingController.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired
};

export default withFormsy(Radium(JumperFormsyPaddingController));



// WEBPACK FOOTER //
// ./src/components/PaddingController/PaddingController.js